import {
  DoorStickerTemplate,
  FlyerTemplate,
  HELLOPRINT_SERVICE_LEVELS,
  PolygraphyProductType,
  StickerTemplate,
} from '../../../../../../../services/exports/Constants';
import { ProductOrderingSteps } from '../../../../../../../views/marketing/polygraphy/orders';

export default {
  title: 'Druckprodukte bestellen',
  steps: {
    [ProductOrderingSteps.ProductInfo]: 'Flyer Details',
    [ProductOrderingSteps.ShippingInfo]: 'Versandinformationen',
    payment: 'Zahlung',
  },
  form: {
    title: 'Details zur Bestellung',
    polygraphy_product_id: {
      label: 'Produkt',
      placeholder: 'Produkt auswählen',
      options: {
        [PolygraphyProductType.Flyer]: {
          name: 'Flyer - {{template}}',
          templates: {
            [FlyerTemplate.One]: 'Vorlage #1 🆕',
            [FlyerTemplate.Two]: 'Vorlage #2 🆕',
            [FlyerTemplate.Three]: 'Vorlage #3',
            [FlyerTemplate.Four]: 'Vorlage #4',
          },
        },
        [PolygraphyProductType.Sticker]: {
          name: 'Aufkleber - {{template}}',
          templates: {
            [StickerTemplate.One]: 'Vorlage #1 🆕',
          },
        },
        [PolygraphyProductType.DoorSticker]: {
          name: 'Türaufkleber - {{template}}',
          templates: {
            [DoorStickerTemplate.One]: 'Vorlage #1 🆕',
            [DoorStickerTemplate.Two]: 'Vorlage #2 🆕',
          },
        },
      },
    },
    quantity: {
      label: 'Menge',
      placeholder: 'Menge eingeben',
    },
    service_level: {
      label: 'Dienstniveau',
      options: {
        [HELLOPRINT_SERVICE_LEVELS.SAVER]: 'Saver',
        [HELLOPRINT_SERVICE_LEVELS.STANDARD]: 'Standard',
        [HELLOPRINT_SERVICE_LEVELS.EXPRESS]: 'Express',
      },
    },
    shipping_company_name: {
      label: 'Firmenname',
      placeholder: 'Firmenname eingeben',
    },
    shipping_salutation: {
      label: 'Begrüßung',
      options: {
        mr: 'Herr',
        mrs: 'Frau',
      },
    },
    shipping_first_name: {
      label: 'Vornamen',
      placeholder: 'Vornamen eingeben',
    },
    shipping_last_name: {
      label: 'Nachname',
      placeholder: 'Nachname eingeben',
    },
    shipping_country: {
      label: 'Land',
      placeholder: 'Land auswählen',
    },
    shipping_state: {
      label: 'Bundesland',
      placeholder: 'Bundesland auswählen',
    },
    shipping_city: {
      label: 'Stadt',
      placeholder: 'Stadt eingeben',
    },
    shipping_address: {
      label: 'Adresse',
      placeholder: 'Adresse eingeben',
    },
    shipping_zip_code: {
      label: 'Postleitzahl',
      placeholder: 'Postleitzahl eingeben',
    },
    shipping_phone_number: {
      label: 'Rufnummer',
      placeholder: 'Rufnummer eingeben',
    },
    create_invoice: {
      options: {
        true: 'Automatische Abrechnung - Sofortige Abrechnung',
        false: 'Kostenlos versenden - Das ist ein Geschenk',
      },
    },
  },
  table: {
    title: 'Frühere Aufträge',
    fields: {
      product: 'Produkt',
      quantity: 'Menge',
      status: 'Status',
      service_level: 'Dienstniveau',
      shipping: 'Versand',
      tracking_url: 'Verfolgungs-Url',
      created: 'Erstellt',
      updated: 'Letzte Aktualisierung',
    },
  },
  labels: {
    shipping_company: 'Firmenname',
    shipping_salutation: 'Begrüßung',
    shipping_first_name: 'Vornamen',
    shipping_last_name: 'Nachname',
    shipping_address: 'Adresse',
    shipping_zip_code: 'Postleitzahl',
    shipping_city: 'Stadt',
    shipping_phone_number: 'Rufnummer',
    show_shipping_details: 'Einzelheiten zum Versand',
    track_order: 'Bestellung verfolgen',
    pending_from_provider: 'Ausstehend vom Anbieter',
  },
  modals: {
    confirmation: {
      title: 'Bestätigen die Bestelldaten',
    },
    free_order_confirmation: {
      title: 'Sind Sie sicher, dass Sie {{product}} kostenlos versenden möchten?',
      description:
        'Sie haben sich entschieden, Ihrem Kunden heute nichts in Rechnung zu stellen.\n Das Produkt wird ohne Bezahlung versendet.',
      buttons: {
        confirm: 'Ja, kostenloser Versand',
      },
    },
  },
  buttons: {
    back_to_templates: 'Zurück zu Vorlagen',
    preview: 'Vorschau',
    next: 'Weiter',
    order: 'Auftrag erstellen',
    confirm: 'Bestätigen',
  },
  feedback: {
    shop_url_used: 'Produkt enthält die URL des Online-Shops (<url>{{url}}</url>). Ist das Absicht?',
    order_total_price: 'Gesamtpreis für die ausgewählten Produkte: <strong>{{amount}} NET</strong>',
  },
  toasts: {
    failed_to_create_order: 'Bestellung konnte nicht erstellt werden',
    order_got_created: 'Auftrag wurde erstellt',
    failed_to_load_data: 'Daten konnten nicht geladen werden',
  },
};
